import React, { Component } from "react";
import axios from "axios";
import ToTop from "react-scroll-top";
import styled from "styled-components";

import { Carousel, NewsFeed, FeatureSet } from "./HomepageLazyLoading";

export default class Home extends Component {
  state = {
    newsArticles: [],
    featureSetGames: []
  };

  componentDidMount() {
    this.getAllNewsArticles();
    this.getAllFeatureSetGames();
    this.props.history.push("/");
  }

  getAllNewsArticles = async () => {
    try {
      const res = await axios.get(
        "https://api.cosmicjs.com/v3/buckets/tripwireinteractivecom-tripwire-company-site/objects?pretty=true&query=%7B%22type%22:%22news-articles%22%7D&limit=10&read_key=6g2KCi7qzTuEkWMEQB6ZDP5v7ZhY7STGFpUPn6lkBpiFEpnqyw&depth=1&props="
      );
      this.setState({ newsArticles: res.data.objects });
    } catch (err) {
      console.log(err);
    }
  };

  getAllFeatureSetGames = async () => {
    try {
      const res = await axios.get(
        "https://api.cosmicjs.com/v3/buckets/tripwireinteractivecom-tripwire-company-site/objects?pretty=true&query=%7B%22type%22:%22feature-set-games%22%7D&limit=10&read_key=6g2KCi7qzTuEkWMEQB6ZDP5v7ZhY7STGFpUPn6lkBpiFEpnqyw&depth=1&props="
      );
      this.setState({ featureSetGames: res.data.objects });
    } catch (err) {
      console.log(err);
    }
  };

  render() {
    return (
      <HomePageWrapper id="top">
        <Carousel newsArticles={this.state.newsArticles} />
        <NewsFeed newsArticles={this.state.newsArticles} />
        <FeatureSet featureSetGames={this.state.featureSetGames} />
        <ToTop hideAt={160} position="top" />
      </HomePageWrapper>
    );
  }
}

const HomePageWrapper = styled.div`
  margin: auto;
`;



// WEBPACK FOOTER //
// ./src/components/home-page/Home.js